var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7058 6.33343C11.89 6.1277 11.8725 5.8116 11.6668 5.6274C11.461 5.44321 11.1449 5.46067 10.9607 5.6664L8.71462 8.17519C8.25949 8.68355 7.95298 9.0241 7.69093 9.24436C7.4413 9.45418 7.29467 9.49992 7.16658 9.49992C7.0385 9.49992 6.89188 9.45418 6.64224 9.24436C6.38019 9.0241 6.07368 8.68355 5.61855 8.17519L5.0391 7.52798C4.85491 7.32224 4.53881 7.30478 4.33307 7.48898C4.12734 7.67317 4.10987 7.98927 4.29407 8.19501L4.89826 8.86986C5.32217 9.34337 5.67574 9.73832 5.99882 10.0099C6.34058 10.2971 6.7092 10.4999 7.16658 10.4999C7.62397 10.4999 7.99259 10.2971 8.33435 10.0099C8.65742 9.73833 9.01099 9.34339 9.43488 8.86989L11.7058 6.33343Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 0.833252C4.04188 0.833252 0.833252 4.04188 0.833252 7.99992C0.833252 11.958 4.04188 15.1666 7.99992 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99992 0.833252ZM1.83325 7.99992C1.83325 4.59416 4.59416 1.83325 7.99992 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99992 14.1666C4.59416 14.1666 1.83325 11.4057 1.83325 7.99992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.680eab5846ed27944abe7e3977c59ce0.svg";
export { ForwardRef as ReactComponent };